'use strict';

module.exports = angular.module('superdostavka.components', [])
.factory('giftManager', ['$http', 'orderManager', 'metrics', '$document', function($http, orderManager, metrics, $document) {
    var giftManager = {

        config: null,
        promise: null,
        current_gift: null,
        init: function() {
            this.getConfig();
        },
        getConfig: function() {
            // Состояние модуля сообщает сервер. Без модуля API правильно отвечает 404,
            // поэтому не запрашиваем его. Старые страницы без признака работают как раньше.
            if ($document[0].body && $document[0].body.getAttribute('data-sd-gift-positions') === '0')
                return;
            if(this.promise)
                return;

            this.promise = $http.get('/rapi/gift_positions_api/get').success(angular.bind(this, function(res) {
                this.config = res;
            }));
        },
        getBonusPercent: function() {
            // Модуль включён, но порогов подарков нет: строки прогресса нет, ошибки в каждой проверке тоже.
            if(!this.config || !this.config.sums || !this.config.sums.length)
                return 0;

            var lastSum = this.config.sums[this.config.sums.length - 1];

            if(orderManager.getTotal() >= lastSum.value)
                return 100;

            return orderManager.getTotal() / lastSum.value * 100;
        },
        setGiftPosition: function(pos) {

            for(var i in this.config.sums)
            {
                var sum = this.config.sums[i];

                if(sum.positions['id'+pos.id])
                {
                    if(sum.value > orderManager.cart.total)
                        return false;

                    orderManager.data.gift_id = pos.id;
                    this.current_gift = pos;

                    metrics.metricsEvent('gift_added');
                }
            }
        },
        getCurrentGift: function() {
            if(!this.current_gift)
                return false;

            for(var i in this.config.sums)
            {
                var sum = this.config.sums[i];

                if(sum.positions['id'+this.current_gift.id])
                {
                    if(sum.value > orderManager.cart.total)
                        return false;

                    return this.current_gift;
                }
            }

            return false;
        },
        getGiftDistance: function() {
            if(!this.config || !this.config.sums || !this.config.sums.length)
                return null;

            var val = this.config.sums[0].value - orderManager.getTotal();

            if(val > 0 && val <= this.config.gift_distance)
                return val;

            return null;
        }
    };

    return giftManager;
}])
.controller('giftPositionsCtrl', ['$scope', 'giftManager', function($scope, giftManager) {

    $scope.giftManager = giftManager;

    if(!$scope.giftManager.config)
        $scope.giftManager.init();
}])
;
